// @ts-ignore
import content from './md/from-quote-to-cash-faster-invoicing.md';

export const meta = {
  slug: 'from-quote-to-cash-faster-invoicing',
  title: 'From Quote to Cash: How Faster Invoicing Improves Your Cash Flow by 30%',
  excerpt: 'Cash flow is the lifeblood of every home service business. Learn how to reduce friction in your invoicing process and get paid faster.',
  date: 'January 2025',
  readTime: '8 min read',
  image: '/docs/from-quote-to-cash-faster-invoicing/header.png'
};

export { content };
